"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.scss"));
var _baseModal = _interopRequireDefault(require("../baseModal"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var classKey = 'info-modal';
var CLASS_NAME = _style.default[classKey];
var InformationModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(InformationModal, _PureComponent);
  var _super = _createSuper(InformationModal);
  function InformationModal() {
    (0, _classCallCheck2.default)(this, InformationModal);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(InformationModal, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_baseModal.default, (0, _extends2.default)({}, this.props, {
        backdrop: this.props.backdrop,
        className: "".concat(CLASS_NAME, " ").concat(this.props.className),
        body: this.props.body,
        footer: this.props.footer,
        id: this.props.id,
        onHide: this.props.onHide,
        show: this.props.show
      }));
    }
  }]);
  return InformationModal;
}(_react.PureComponent);
InformationModal.propTypes = {
  backdrop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  body: _propTypes.default.element.isRequired,
  className: _propTypes.default.string,
  footer: _propTypes.default.element,
  id: _propTypes.default.string,
  onHide: _propTypes.default.func,
  show: _propTypes.default.bool,
  title: _propTypes.default.string
};
InformationModal.defaultProps = {
  backdrop: true,
  className: '',
  footer: null,
  id: '',
  onHide: function onHide() {
    return null;
  },
  show: false,
  title: 'Info'
};
var _default = InformationModal;
exports.default = _default;